module.exports = __webpack_public_path__ + "static/media/water-165219_960_720.a8b94ea7.jpg";